/**
 * Finds the plan error in whatever a refused call returned: an edge function's
 * non-2xx response (supabase.functions.invoke puts the Response in
 * `error.context`), a database guard's PostgREST error (code PT402 / PT403,
 * the error as JSON in `details`), or a plan error object itself.
 */
import {
  asPlanError,
  planErrorFromDb,
  type PlanError,
} from "../../../supabase/functions/_shared/plan-errors";

export async function readPlanError(error: unknown): Promise<PlanError | null> {
  if (!error || typeof error !== "object") return null;

  const fromDb = planErrorFromDb(error as { code?: string; details?: string | null });
  if (fromDb) return fromDb;

  const direct = asPlanError(error);
  if (direct) return direct;

  const context = (error as { context?: unknown }).context;
  if (context instanceof Response) {
    if (context.status !== 402 && context.status !== 403) return null;
    try {
      return asPlanError(await context.clone().json());
    } catch {
      return null;
    }
  }
  return null;
}
